import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { PushSubscriptionPayload } from "types/PushSubscriptionTypes";

export const useCreatePushSubscription = (
  options?: UseMutationOptions<any, Error, PushSubscriptionPayload>
) => {
  return useMutation({
    mutationKey: ["createPushSubscription"],
    mutationFn: async (subscription: PushSubscriptionPayload) => {
      return axiosInstance
        .post("push-subscriptions", subscription)
        .then((res) => res.data);
    },
    onMutate: (variables) => {
      if (options && options.onMutate) {
        // @ts-ignore
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};
